/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	CompanyInternshipState,
	CompanyInternshipStateFromJSON,
	CompanyInternshipStateFromJSONTyped,
	CompanyInternshipStateToJSON,
} from "./CompanyInternshipState";
import {
	FacultyDTO,
	FacultyDTOFromJSON,
	FacultyDTOFromJSONTyped,
	FacultyDTOToJSON,
} from "./FacultyDTO";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";
import {
	StudyProgramDTO,
	StudyProgramDTOFromJSON,
	StudyProgramDTOFromJSONTyped,
	StudyProgramDTOToJSON,
} from "./StudyProgramDTO";

/**
 *
 * @export
 * @interface MentorshipDTO
 */
export interface MentorshipDTO {
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	id: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	recruiterId: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	recruiterName: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	recruiterAvatar: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	recruiterDepartment?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	address?: string | null;
	/**
	 *
	 * @type {CompanyInternshipState}
	 * @memberof MentorshipDTO
	 */
	state?: CompanyInternshipState;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	internshipId: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	internshipName: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	description: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	shortDescription: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	category: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	location: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	placeId: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	mentorId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	mentorName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	mentorCNP?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	mentorDescription?: string | null;
	/**
	 *
	 * @type {Array<FacultyDTO>}
	 * @memberof MentorshipDTO
	 */
	faculties: Array<FacultyDTO>;
	/**
	 *
	 * @type {Array<StudyProgramDTO>}
	 * @memberof MentorshipDTO
	 */
	studyPrograms: Array<StudyProgramDTO>;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof MentorshipDTO
	 */
	years: Array<StudentYearEnum>;
	/**
	 *
	 * @type {Date}
	 * @memberof MentorshipDTO
	 */
	availableFrom: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof MentorshipDTO
	 */
	availableTo: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof MentorshipDTO
	 */
	startingDate: Date;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTO
	 */
	initialAvailablePositions: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTO
	 */
	availablePositions: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTO
	 */
	enrolledStudentsCount: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTO
	 */
	applicantsCount: number;
	/**
	 *
	 * @type {number}
	 * @memberof MentorshipDTO
	 */
	viewCount?: number;
	/**
	 *
	 * @type {string}
	 * @memberof MentorshipDTO
	 */
	companyId?: string;
}

export function MentorshipDTOFromJSON(json: any): MentorshipDTO {
	return MentorshipDTOFromJSONTyped(json, false);
}

export function MentorshipDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): MentorshipDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: json["id"],
		recruiterId: json["recruiterId"],
		recruiterName: json["recruiterName"],
		recruiterAvatar: json["recruiterAvatar"],
		recruiterDepartment: !exists(json, "recruiterDepartment")
			? undefined
			: json["recruiterDepartment"],
		address: !exists(json, "address") ? undefined : json["address"],
		state: !exists(json, "state")
			? undefined
			: CompanyInternshipStateFromJSON(json["state"]),
		internshipId: json["internshipId"],
		internshipName: json["internshipName"],
		description: json["description"],
		shortDescription: json["shortDescription"],
		category: json["category"],
		location: json["location"],
		placeId: json["placeId"],
		mentorId: !exists(json, "mentorId") ? undefined : json["mentorId"],
		mentorName: !exists(json, "mentorName") ? undefined : json["mentorName"],
		mentorCNP: !exists(json, "mentorCNP") ? undefined : json["mentorCNP"],
		mentorDescription: !exists(json, "mentorDescription")
			? undefined
			: json["mentorDescription"],
		faculties: (json["faculties"] as Array<any>).map(FacultyDTOFromJSON),
		studyPrograms: (json["studyPrograms"] as Array<any>).map(
			StudyProgramDTOFromJSON
		),
		years: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		availableFrom: new Date(json["availableFrom"]),
		availableTo: new Date(json["availableTo"]),
		startingDate: new Date(json["startingDate"]),
		initialAvailablePositions: json["initialAvailablePositions"],
		availablePositions: json["availablePositions"],
		enrolledStudentsCount: json["enrolledStudentsCount"],
		applicantsCount: json["applicantsCount"],
		viewCount: !exists(json, "viewCount") ? undefined : json["viewCount"],
		companyId: !exists(json, "companyId") ? undefined : json["companyId"],
	};
}

export function MentorshipDTOToJSON(value?: MentorshipDTO | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		recruiterId: value.recruiterId,
		recruiterName: value.recruiterName,
		recruiterAvatar: value.recruiterAvatar,
		recruiterDepartment: value.recruiterDepartment,
		address: value.address,
		state: CompanyInternshipStateToJSON(value.state),
		internshipId: value.internshipId,
		internshipName: value.internshipName,
		description: value.description,
		shortDescription: value.shortDescription,
		category: value.category,
		location: value.location,
		placeId: value.placeId,
		mentorId: value.mentorId,
		mentorName: value.mentorName,
		mentorCNP: value.mentorCNP,
		mentorDescription: value.mentorDescription,
		faculties: (value.faculties as Array<any>).map(FacultyDTOToJSON),
		studyPrograms: (value.studyPrograms as Array<any>).map(
			StudyProgramDTOToJSON
		),
		years: (value.years as Array<any>).map(StudentYearEnumToJSON),
		availableFrom: value.availableFrom.toISOString(),
		availableTo: value.availableTo.toISOString(),
		startingDate: value.startingDate.toISOString(),
		initialAvailablePositions: value.initialAvailablePositions,
		availablePositions: value.availablePositions,
		enrolledStudentsCount: value.enrolledStudentsCount,
		applicantsCount: value.applicantsCount,
		viewCount: value.viewCount,
		companyId: value.companyId,
	};
}
